import { render, staticRenderFns } from "./UserProfileCard.vue?vue&type=template&id=0d8db79c&scoped=true&"
import script from "./UserProfileCard.ts?vue&type=script&lang=ts&"
export * from "./UserProfileCard.ts?vue&type=script&lang=ts&"
import style0 from "./UserProfileCard.vue?vue&type=style&index=0&id=0d8db79c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8db79c",
  null
  
)

export default component.exports